import CustomBorderedText from "@Components/CustomBorderedText"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { baseColors, baseFontFamily, dimensions } from "@Constants/baseStyles"
import React, { useEffect, useState } from "react"
import { Image, ScrollView, TouchableOpacity, View } from "react-native"
import { RFValue } from "react-native-responsive-fontsize"
import styles from "./styles"
import { ResizeMode, Video } from "expo-av"
import { PostService } from "@Services/Posts"
import { useRecoilState } from "recoil"
import { globalLoadingVisibleAtom } from "@Recoil/Atom/globalLoadingAtom"
import { ShowToast } from "@Components/ToastNotification/ToastNotification"
import moment from "moment"
import { dbDateFormat, localDateFormat } from "@Utils/utils"
import { ArticleTypes, message } from "@Constants/constant"
import Markdown from "react-native-markdown-renderer"
import { Spacer } from "@Components/Space"
import { ActivityIndicator } from "react-native-paper"
import { Ionicons } from "@expo/vector-icons"
import ReactPlayer from "react-player"

const VideosDetails = (props) => {
    const { route } = props
    const id = route?.params?.contentId ?? 0
    const content = route?.params?.content ?? null
    const handleShare = () => console.log("Share Content")
    const video = React.useRef(null)
    const [fetchingDetails, setFetchingDetails] = useState(true)
    const [viewed, setViewed] = useState(false)
    const [loading, setLoading] = useRecoilState(globalLoadingVisibleAtom)
    const [loadingVideos, setLoadingVideos] = useState(true)
    const [played, setPlayed] = useState(false)
    const [post, setPost] = useState(null)

    const [time, setTime] = useState({
        seconds: 0,
        minutes: 0,
        hours: 0
    })

    const isCloseToBottom = ({ layoutMeasurement, contentOffset, contentSize }) => {
        const paddingToBottom = 20
        return layoutMeasurement.height + contentOffset.y >= contentSize.height - paddingToBottom
    }

    const onPlayBackStatusUpdate = (playbackStatus) => {
        if (playbackStatus.didJustFinish) {
            setPostAsViewed()
        }
    }

    const handleFetchVideosDetails = () => {
        if (id) {
            setFetchingDetails(true)
            PostService.getDetails(id)
                .then((response) => {
                    const data = response.data?.data
                    if (data) {
                        setPost(data)
                    }
                    setFetchingDetails(false)
                })
                .catch((e) => {
                    setFetchingDetails(false)
                    ShowToast({ type: "error", message: message.serverError })
                })
        }
    }

    useEffect(() => {
        if (content?.id) {
            setFetchingDetails(false)
            setPost(content)
        } else {
            handleFetchVideosDetails
        }
    }, [id, content])

    const setPostAsViewed = () => {
        if (id !== 0 && !viewed) {
            setLoading(true)
            PostService.setViewed(id)
                .then((response) => {
                    setLoading(false)
                    setViewed(true)
                    ShowToast({ type: "success", message: "L'article a été marqué comme lu" })
                })
                .catch((e) => {
                    setLoading(false)
                })
        }
    }

    useEffect(() => {
        let isCancelled = false

        const advanceTime = () => {
            setTimeout(() => {
                let nSeconds = time.seconds
                let nMinutes = time.minutes
                let nHours = time.hours

                nSeconds++

                if (nSeconds > 59) {
                    nMinutes++
                    nSeconds = 0
                }
                if (nMinutes > 59) {
                    nHours++
                    nMinutes = 0
                }
                if (nHours > 24) {
                    nHours = 0
                }

                !isCancelled && setTime({ seconds: nSeconds, minutes: nMinutes, hours: nHours })
            }, 1000)
        }
        advanceTime()

        return () => {
            if (post?.postType.code === ArticleTypes.text || post?.postType.code === ArticleTypes.image) {
                if (time.seconds > 20) {
                    setPostAsViewed()
                }
            }
            isCancelled = true
        }
    }, [time])

    const handlePlayed = () => setPlayed(!played)

    return (
        <View style={styles.container}>
            {fetchingDetails ? (
                <ActivityIndicator color={baseColors.green.primary} size={"large"} style={{ padding: 20 }} />
            ) : (
                <>
                    <View style={styles.header}>
                        {post && (
                            <CustomBorderedText label={post?.axis?.name?.replace("Axe", "").trim() ?? "Diététique"} />
                        )}
                        {/* <TouchableOpacity onPress={handleShare}>
                            <SvgShare />
                        </TouchableOpacity> */}
                    </View>

                    <ScrollView
                        onScroll={({ nativeEvent }) => {
                            if (isCloseToBottom(nativeEvent)) {
                                setPostAsViewed()
                            }
                        }}
                        scrollEventThrottle={400}
                        showsVerticalScrollIndicator={false}
                        contentContainerStyle={{ paddingBottom: 100 }}
                    >
                        <BreeSerifText style={styles.title} fontSize={RFValue(26)}>
                            {post?.title}
                        </BreeSerifText>
                        {post?.postType.code === ArticleTypes.image ? (
                            <Image
                                source={{
                                    uri: post?.image?.url
                                }}
                                style={{ width: "100%", height: 200, borderRadius: 10 }}
                            />
                        ) : post?.postType.code === ArticleTypes.video ? (
                            <View>
                                {/* <View style={{ aspectRatio: 16 / 9, width: "100%" }}>
                                    <Video
                                        isLooping
                                        useNativeControls
                                        onLoad={() => setLoadingVideos(false)}
                                        ref={video}
                                        style={styles.video}
                                        source={{
                                            uri: post?.video?.url
                                        }}
                                        shouldPlay={played}
                                        resizeMode={ResizeMode.COVER}
                                        onPlaybackStatusUpdate={(status) => onPlayBackStatusUpdate(status)}
                                    />
                                </View> 

                                {!played && (<View
                                        style={{
                                            justifyContent: "center",
                                            alignItems: "center",
                                            width: "100%",
                                            height: dimensions.fullHeight / 3 + 10,
                                            position: "absolute",
                                            backgroundColor: loadingVideos ? baseColors.orange.light : "transparent"
                                        }}
                                    >
                                        <Ionicons name="play-circle" color={baseColors.green.primary} size={80} />
                                        {loadingVideos && <BreeSerifText>Chargement en cours...</BreeSerifText>}
                                    </View>
                                )} */}

                                <ReactPlayer
                                    loop
                                    playing={played}
                                    ref={video}
                                    url={post?.video?.url}
                                    controls
                                    width="100%"
                                    height="100%"
                                    onPlaybackStatusUpdate={(status) => onPlayBackStatusUpdate(status)}
                                />

                                {/* {loadingVideos && (
                                    <View
                                        style={{
                                            justifyContent: "center",
                                            alignItems: "center",
                                            width: "100%",
                                            height: dimensions.fullHeight / 3 + 10,
                                            position: "absolute",
                                            backgroundColor: loadingVideos ? baseColors.orange.light : "transparent"
                                        }}
                                    >
                                        <BreeSerifText>Chargement en cours...</BreeSerifText>
                                    </View>
                                )} */}
                            </View>
                        ) : (
                            <></>
                        )}

                        <Markdown>{post?.content ?? ""}</Markdown>

                        <Spacer height={20} />

                        <OpenSansText fontSize={RFValue(14)} defaultFontFamily={baseFontFamily.OpenSansRegular}>
                            {post?.postType?.code === ArticleTypes.video
                                ? `${post?.video?.creator?.firstName} ${post?.video?.creator?.lastName}`
                                : post?.postType.code === ArticleTypes.image
                                ? `${post?.image?.creator?.firstName} ${post?.image?.creator?.lastName}`
                                : "Non renseigné"}
                        </OpenSansText>

                        <OpenSansText
                            style={styles.author}
                            fontSize={RFValue(14)}
                            defaultFontFamily={baseFontFamily.OpenSansRegular}
                        >
                            Le {moment(post?.createdAt, dbDateFormat + "HH:mm").format(localDateFormat + " " + "HH:mm")}
                        </OpenSansText>
                    </ScrollView>
                </>
            )}
        </View>
    )
}

export default VideosDetails
